import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { RedirectsFormFieldsNames } from '../helpers/types';

export const useRedirectFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [RedirectsFormFieldsNames.TYPE]: [requiredRule],
    [RedirectsFormFieldsNames.SOURCE]: [requiredRule],
    [RedirectsFormFieldsNames.TARGET]: [requiredRule],
  };
};
